import styled from 'styled-components';
import { FunctionComponent } from 'react';
import { Steps } from 'antd';
import { StepsProps } from 'antd/lib/steps';

export const DetailsSteps: FunctionComponent<StepsProps> = styled(Steps)`
  max-width: 70%;

  .ant-steps-item-content .ant-steps-item-description {
    max-width: 18rem;
  }
`;

export const DetailsCards = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  .ant-card-bordered {
    flex: 1 1 200px;
    &:nth-child(2) {
      margin: 0 20px;
    }
  }

  .ant-card-head-title {
    font-weight: bold;
  }
`;

export const DetailsLoadingWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
`;
